export const primaryThemeFonts = {};
